module.exports = __webpack_public_path__ + "media/site_templates/www.bathroomrenovations.biz/images/our_services_2-0239a158807a839bb3a5d6e3fd17c417.jpg";